import { useContext } from 'react'
import { getPhutureContext, PhutureState } from '../phuture-context'

export function usePhuture(): PhutureState {
  //PhutureState & PhutureCallbacks
  const context = useContext(getPhutureContext())
  if (!context) throw new Error('`usePhuture` must be used within a `PhutureProvider`.')

  return context
}
